export const defaultMaxResults = 25;

export enum filterId {
  query = 'query',
  subscriberGroup = 'subscriberGroup',
  application = 'application',
  operation = 'operation'
}

export const mobileWidth = 766;
